// 价格过滤功能
class RangeSlider {
  constructor(options = {}) {
    // 合并配置
    this.config = {
      minValue: 0,
      maxValue: 2000,
      step: 1,
      initialMin: 0,
      initialMax: 2000,
      currency: '¥',
      minIntervalRatio: 0.05,
      minAmountInputId: 'minAmountInput',
      maxAmountInputId: 'maxAmountInput',
      minAmountReadonlyId: 'minAmountReadonly',
      maxAmountReadonlyId: 'maxAmountReadonly',
      minAmountBoxId: 'minAmountBox',
      maxAmountBoxId: 'maxAmountBox',
      minThumbId: 'minThumb',
      maxThumbId: 'maxThumb',
      sliderRangeId: 'sliderRange',
      sliderTrackSelector: '.slider-track',
      onValuesChange: null, // 值变化回调函数
      ...options
    };

    // 计算最小间隔值
    this.config.minInterval = Math.round(
      (this.config.maxValue - this.config.minValue) * this.config.minIntervalRatio
    );

    // DOM 元素
    this.minThumb = document.getElementById(this.config.minThumbId);
    this.maxThumb = document.getElementById(this.config.maxThumbId);
    this.sliderRange = document.getElementById(this.config.sliderRangeId);
    this.minAmountInput = document.getElementById(this.config.minAmountInputId);
    this.maxAmountInput = document.getElementById(this.config.maxAmountInputId);
    this.minAmountReadonly = document.getElementById(this.config.minAmountReadonlyId);
    this.maxAmountReadonly = document.getElementById(this.config.maxAmountReadonlyId);
    this.minAmountBox = document.getElementById(this.config.minAmountBoxId);
    this.maxAmountBox = document.getElementById(this.config.maxAmountBoxId);
    
    this.noResults = document.querySelector('.no-results');
    // 状态变量
    this.minValue = this.config.initialMin;
    this.maxValue = this.config.initialMax;
    this.activeThumb = null;
    this.sliderWidth = 0;
    this.sliderLeft = 0;
    this.isEditing = false;

    // 绑定事件处理函数
    this.startDrag = this.startDrag.bind(this);
    this.drag = this.drag.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
    this.startDragTouch = this.startDragTouch.bind(this);
    this.dragTouch = this.dragTouch.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);

    // 初始化
    this.init();
  }

  // 初始化
  init() {
    this.updateSliderDimensions();
    this.updateThumbPositions();
    this.updateUI();

    // 事件监听
    this.minThumb.addEventListener('mousedown', this.startDrag);
    this.maxThumb.addEventListener('mousedown', this.startDrag);
    document.addEventListener('mousemove', this.drag);
    document.addEventListener('mouseup', this.stopDrag);

    // 触摸事件支持
    this.minThumb.addEventListener('touchstart', this.startDragTouch);
    this.maxThumb.addEventListener('touchstart', this.startDragTouch);
    document.addEventListener('touchmove', this.dragTouch);
    document.addEventListener('touchend', this.stopDrag);

    // 金额点击编辑事件
    this.setupAmountEditing(
      this.minAmountInput,
      this.minAmountReadonly,
      'min'
    );
    this.setupAmountEditing(
      this.maxAmountInput,
      this.maxAmountReadonly,
      'max'
    );

    // 窗口大小改变时更新滑块尺寸
    window.addEventListener('resize', () => this.updateSliderDimensions());

    // 初始化时验证间隔
    this.validateInterval('min');
  }

  // 设置金额编辑功能
  setupAmountEditing(inputElement, readonlyElement, type) {
    // 点击只读元素时，显示输入框
    readonlyElement.addEventListener('click', () => {
      if (!this.isEditing) {
        this.startEditing(inputElement, readonlyElement, type);
      }
    });

    // 输入框失去焦点时，保存值
    inputElement.addEventListener('blur', () => {
      this.saveValue(inputElement, readonlyElement, type);
    });

    // 输入框按回车键时，保存值
    inputElement.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        this.saveValue(inputElement, readonlyElement, type);
        inputElement.blur();
      } else if (e.key === 'Escape') {
        this.cancelEditing(inputElement, readonlyElement, type);
      }
    });

    // 输入框输入时验证
    inputElement.addEventListener('input', (e) => {
      this.validateInput(e.target, type);
    });
  }

  // 验证输入
  validateInput(inputElement, type) {
    let value = parseInt(inputElement.value) || 0;
    
    // 确保是整数
    if (value < 0) {
      value = 0;
    }
    
    // 根据类型限制最大值
    if (type === 'min') {
      value = Math.min(value, this.config.maxValue - this.config.minInterval);
    } else {
      value = Math.max(value, this.minValue + this.config.minInterval);
    }
    
    inputElement.value = value;
  }

  // 开始编辑
  startEditing(inputElement, readonlyElement, type) {
    this.isEditing = true;

    // 隐藏只读元素，显示输入框
    readonlyElement.style.display = 'none';
    inputElement.style.display = 'block';
    inputElement.readOnly = false;

    // 设置输入框值（去除千位分隔符）
    const currentValue = type === 'min' ? this.minValue : this.maxValue;
    inputElement.value = currentValue;

    // 选中全部文本
    inputElement.focus();
    inputElement.select();

    // 高亮金额框
    if (type === 'min') {
      this.minAmountBox.classList.add('active');
    } else {
      this.maxAmountBox.classList.add('active');
    }
  }

  // 保存值
  saveValue(inputElement, readonlyElement, type) {
    if (!this.isEditing) return;

    this.isEditing = false;

    // 获取并验证输入值
    let value = parseInt(inputElement.value) || 0;

    // 根据类型设置范围限制
    if (type === 'min') {
      value = Math.max(this.config.minValue, Math.min(value, this.config.maxValue));
      // 确保不超过最大值减去最小间隔
      value = Math.min(value, this.maxValue - this.config.minInterval);
    } else {
      value = Math.max(this.config.minValue, Math.min(value, this.config.maxValue));
      // 确保不小于最小值加上最小间隔
      value = Math.max(value, this.minValue + this.config.minInterval);
    }

    // 四舍五入到步长
    value = Math.round(value / this.config.step) * this.config.step;

    // 更新状态
    if (type === 'min') {
      this.minValue = value;
      // 验证并调整最大值
      this.validateInterval('min');
    } else {
      this.maxValue = value;
      // 验证并调整最小值
      this.validateInterval('max');
    }

    // 隐藏输入框，显示只读元素
    inputElement.style.display = 'none';
    readonlyElement.style.display = 'inline';
    inputElement.readOnly = true;

    // 更新UI
    this.updateThumbPositions();
    this.updateUI();

    // 移除高亮
    if (type === 'min') {
      this.minAmountBox.classList.remove('active');
    } else {
      this.maxAmountBox.classList.remove('active');
    }

    // 调用回调函数
    this.triggerChangeCallback();
  }

  // 取消编辑
  cancelEditing(inputElement, readonlyElement, type) {
    this.isEditing = false;

    // 隐藏输入框，显示只读元素
    inputElement.style.display = 'none';
    readonlyElement.style.display = 'inline';
    inputElement.readOnly = true;

    // 移除高亮
    if (type === 'min') {
      this.minAmountBox.classList.remove('active');
    } else {
      this.maxAmountBox.classList.remove('active');
    }
  }

  // 文档点击事件处理
  onDocumentClick(e) {
    if (this.isEditing) {
      const isMinInput = this.minAmountInput.contains(e.target) || this.minAmountReadonly.contains(e.target);
      const isMaxInput = this.maxAmountInput.contains(e.target) || this.maxAmountReadonly.contains(e.target);
      
      if (!isMinInput && !isMaxInput) {
        // 如果点击了其他地方，保存当前正在编辑的值
        if (this.minAmountInput.style.display === 'block') {
          this.saveValue(this.minAmountInput, this.minAmountReadonly, 'min');
        } else if (this.maxAmountInput.style.display === 'block') {
          this.saveValue(this.maxAmountInput, this.maxAmountReadonly, 'max');
        }
      }
    }
  }

  // 验证并调整间隔
  validateInterval(changed) {
    const currentInterval = this.maxValue - this.minValue;

    if (currentInterval < this.config.minInterval) {
      // 间隔太小，需要调整
      if (changed === 'min') {
        // 最小值改变了，调整最大值
        this.maxValue = this.minValue + this.config.minInterval;
      } else {
        // 最大值改变了，调整最小值
        this.minValue = this.maxValue - this.config.minInterval;
      }

      // 确保在范围内
      this.minValue = Math.max(this.config.minValue, this.minValue);
      this.maxValue = Math.min(this.config.maxValue, this.maxValue);
    }
  }

  // 更新滑块尺寸
  updateSliderDimensions() {
    const track = document.querySelector(this.config.sliderTrackSelector);
    if (!track) return;
    
    const rect = track.getBoundingClientRect();
    this.sliderWidth = rect.width;
    this.sliderLeft = rect.left;
  }

  // 开始拖动（鼠标）
  startDrag(e) {
    e.preventDefault();
    this.activeThumb = e.target;
    this.activeThumb.classList.add('active');

    if (this.activeThumb === this.minThumb) {
      this.minAmountBox.classList.add('active');
    } else {
      this.maxAmountBox.classList.add('active');
    }
  }

  // 开始拖动（触摸）
  startDragTouch(e) {
    e.preventDefault();
    this.activeThumb = e.target;
    this.activeThumb.classList.add('active');

    if (this.activeThumb === this.minThumb) {
      this.minAmountBox.classList.add('active');
    } else {
      this.maxAmountBox.classList.add('active');
    }
  }

  // 拖动（鼠标）
  drag(e) {
    if (!this.activeThumb) return;

    e.preventDefault();
    const clientX = e.clientX;
    this.updateThumbPosition(clientX);
  }

  // 拖动（触摸）
  dragTouch(e) {
    if (!this.activeThumb || !e.touches[0]) return;

    e.preventDefault();
    const clientX = e.touches[0].clientX;
    this.updateThumbPosition(clientX);
  }

  // 更新滑块位置
  updateThumbPosition(clientX) {
    let position = clientX - this.sliderLeft;
    position = Math.max(0, Math.min(position, this.sliderWidth));

    const percentage = position / this.sliderWidth;
    const value = this.config.minValue + (percentage * (this.config.maxValue - this.config.minValue));
    const roundedValue = Math.round(value / this.config.step) * this.config.step;

    if (this.activeThumb === this.minThumb) {
      // 限制最小值不能超过最大值减去最小间隔
      const newMin = Math.min(roundedValue, this.maxValue - this.config.minInterval);
      this.minValue = Math.max(this.config.minValue, newMin);
    } else {
      // 限制最大值不能小于最小值加上最小间隔
      const newMax = Math.max(roundedValue, this.minValue + this.config.minInterval);
      this.maxValue = Math.min(this.config.maxValue, newMax);
    }

    this.updateThumbPositions();
    this.updateUI();
  }

  // 停止拖动
  stopDrag() {
    if (this.activeThumb) {
      this.activeThumb.classList.remove('active');

      if (this.activeThumb === this.minThumb) {
        this.minAmountBox.classList.remove('active');
      } else {
        this.maxAmountBox.classList.remove('active');
      }

      this.activeThumb = null;
      this.triggerChangeCallback();
    }
  }

  // 更新滑块位置
  updateThumbPositions() {
    const minPercentage = (this.minValue - this.config.minValue) / (this.config.maxValue - this.config.minValue) * 100;
    const maxPercentage = (this.maxValue - this.config.minValue) / (this.config.maxValue - this.config.minValue) * 100;

    this.minThumb.style.left = `${minPercentage}%`;
    this.maxThumb.style.left = `${maxPercentage}%`;
    this.sliderRange.style.left = `${minPercentage}%`;
    this.sliderRange.style.width = `${maxPercentage - minPercentage}%`;
  }

  // 更新UI显示
  updateUI() {
    this.minAmountReadonly.textContent = this.formatNumber(this.minValue);
    this.maxAmountReadonly.textContent = this.formatNumber(this.maxValue);

    // 更新输入框的值（如果需要的话）
    if (!this.isEditing) {
      this.minAmountInput.value = this.minValue;
      this.maxAmountInput.value = this.maxValue;
    }
  }

  // 设置数值
  setValues(min, max, changed = 'both') {
    this.minValue = Math.max(this.config.minValue, min);
    this.maxValue = Math.min(this.config.maxValue, max);

    // 确保最小值不超过最大值
    if (this.minValue > this.maxValue) {
      this.minValue = this.maxValue - this.config.minInterval;
    }

    // 验证并调整间隔
    this.validateInterval(changed);

    this.updateThumbPositions();
    this.updateUI();
    this.triggerChangeCallback();
  }

  // 获取当前值
  getValues() {
    return {
      min: this.minValue,
      max: this.maxValue
    };
  }

  // 重置为初始值
  reset() {
    this.minValue = this.config.initialMin;
    this.maxValue = this.config.initialMax;
    this.updateThumbPositions();
    this.updateUI();
    this.triggerChangeCallback();
  }

  // 格式化数字（添加千位分隔符）
  formatNumber(num) {
    return num.toLocaleString('zh-CN');
  }

  // 格式化货币显示
  formatCurrency(num) {
    return `${this.config.currency}${this.formatNumber(num)}`;
  }

  // 触发值变化回调
  triggerChangeCallback() {
    this.filterProducts(this.minValue, this.maxValue);
    if (typeof this.config.onValuesChange === 'function') {
      this.config.onValuesChange({
        min: this.minValue,
        max: this.maxValue
      });
    }
  }

    // 核心过滤逻辑
  filterProducts(minPrice, maxPrice) {
    let visibleCount = 0;
    const productItems = document.querySelectorAll('.feature-collection__item');
    console.log('productItems', productItems);
    
     productItems.forEach(item => {
      item.style.display = '';
    });
    productItems.forEach(item => {
      const productMinPrice = Number(item.dataset.priceMin) / 100;
      const productMaxPrice = Number(item.dataset.priceMax) / 100;
      
      // 检查产品的任意价格是否在范围内
      // 只要产品的最低价在范围内就显示
      const shouldShow = this.isPriceInRange(
        productMinPrice, 
        productMaxPrice, 
        minPrice, 
        maxPrice
      );
      
      if (shouldShow) {
        item.style.display = '';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });
    
    // 显示/隐藏"无结果"提示
    if (this.noResults) {
      this.noResults.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  }
  
  // 判断价格是否在范围内
  isPriceInRange(productMin, productMax, filterMin, filterMax) {
    return productMin >= filterMin && productMin <= filterMax;
  }

  // 销毁方法，清理事件监听
  destroy() {
    this.minThumb.removeEventListener('mousedown', this.startDrag);
    this.maxThumb.removeEventListener('mousedown', this.startDrag);
    document.removeEventListener('mousemove', this.drag);
    document.removeEventListener('mouseup', this.stopDrag);
    this.minThumb.removeEventListener('touchstart', this.startDragTouch);
    this.maxThumb.removeEventListener('touchstart', this.startDragTouch);
    document.removeEventListener('touchmove', this.dragTouch);
    document.removeEventListener('touchend', this.stopDrag);
    window.removeEventListener('resize', () => this.updateSliderDimensions());
    document.removeEventListener('click', this.onDocumentClick);
  }
}

if (!window.Maximize.loadedScript.includes('featured-collection.js')) {
  window.Maximize.loadedScript.push('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        currentHandle: 'sotong-cuttlefish-series',
        loading: true,
        loaded: [],
        allProducts: [], // 新增：存储所有产品
        rangeSlider: null,
        // 新增：初始化时加载所有产品
        async init() {
          // await this.fetchAllProducts();
          this.rangeSlider = new RangeSlider({
            minValue: 0,
            maxValue: 300,
            initialMin: 0,
            initialMax: 300,
            currency: '',
            minIntervalRatio: 0.05,
            onValuesChange: function(values) {
              console.log('范围变化:', values);
            }
          });
        },
        
        // 新增：获取所有产品的方法
        async fetchAllProducts(handle, demoId) {
          try {
            // 从当前 URL 或其他方式获取 collection handle
            const collectionHandle = handle || this.getCollectionHandle();
            if (!collectionHandle) return;
            this.loading = true;
            let page = 1;
            let allProducts = [];
            
            // 循环获取所有页的产品
            while (true) {
              const url = `/collections/${collectionHandle}/products.json?limit=250&page=${page}`;
              const response = await fetch(url);
              
              if (!response.ok) break;
              
              const data = await response.json();
              const container = document.querySelector(`#collection_products__${demoId - 1}`);
              const allItems = document.querySelectorAll(`#collection_products__${demoId - 1} .feature-collection__item`);
              const template = container.querySelector('.feature-collection__item');
              if (!template) {
                console.error('Template not found');
                return;
              }
               // 克隆模板并隐藏原始模板（或者直接用第一个产品）
              const templateClone = template.cloneNode(true);
              data.products.filter((product) => {
                console.log('allItems.find((item) => product.id === item.dataset.productId)', allItems.find((item) => product.id === item.dataset.productId));
                
                return true;
              }).forEach((product, index) => {
                console.log('product', product);
                const clone = templateClone.cloneNode(true);
                
                // 获取第一个 variant
                const firstVariant = product.variants[0];
                const lastVariant = product.variants[product.variants.length - 1];
                
                // ========== 更新容器属性 ==========
                clone.id = `ProductCard_${sectionId}--${product.id}-${index}`;
                clone.dataset.currentVariantId = firstVariant.id;
                clone.dataset.priceMin = Number(firstVariant.price) * 100;
                clone.dataset.priceMax = Number(lastVariant.price) * 100;
                clone.dataset.variants = JSON.stringify(product.variants);
                clone.style.setProperty('--animation-order', index + 1);
                
                // ========== 更新产品属性 ==========
                const productLink = clone.querySelector('.link-product-variant');
                if (productLink) {
                  
                  productLink.setAttribute('x-labels-data', JSON.stringify({
                    id: product.id,
                    available: firstVariant.available,
                    title: product.title,
                    ...firstVariant,
                    price: Number(firstVariant.price) * 100,
                    price_with_currency: `${firstVariant.price}`,
                  }))
                }

                // ========== 更新产品图片 ==========
                // 1. 更新第一张图片（主图）
                const firstSlide = clone.querySelector('.slide-item.is-active');
                if (firstSlide) {
                  const firstImg = firstSlide.querySelector('img');
                  if (firstImg) {
                    const firstImage = product.images[0];
                    firstImg.src = firstImage.src;
                    firstImg.alt = product.title;
                    firstImg.width = firstImage.width;
                    firstImg.height = firstImage.height;
                    firstImg.dataset.mediaId = firstImage.id;
                    
                    // 更新 srcset（响应式图片）
                    firstImg.srcset = `
                      ${firstImage.src.replace('.jpg', '_300x.jpg')} 300w,
                      ${firstImage.src.replace('.jpg', '_500x.jpg')} 500w,
                      ${firstImage.src.replace('.jpg', '_800x.jpg')} 800w
                    `;
                  }
                }
                
                // 2. 处理悬停图片（第二张及以后）
                const allSlides = clone.querySelectorAll('.slide-item');
                
                // 移除模板中多余的 slide
                allSlides.forEach((slide, slideIndex) => {
                  if (slideIndex > 0) {
                    slide.remove();
                  }
                });
                
                // 添加新的悬停图片
                if (product.images.length > 1) {
                  const linkContainer = clone.querySelector('.link-product-variant');
                  const maxImages = 4; // 最多显示4张图片
                  
                  for (let i = 1; i < Math.min(product.images.length, maxImages); i++) {
                    const image = product.images[i];
                    
                    // 创建新的 slide
                    const newSlide = document.createElement('div');
                    newSlide.className = 'slide-item h-full pointer-events-none';
                    
                    // 如果是第二张图片，添加悬停效果类
                    if (i === 1) {
                      newSlide.classList.add('transition-opacity', 'duration-300', 'opacity-0', 'second-hover-image', 'absolute', 'top-0');
                    }
                    
                    // 创建图片元素
                    const img = document.createElement('img');
                    img.className = 'product-card__image object-cover w-full h-full';
                    img.src = image.src;
                    img.alt = product.title;
                    img.width = image.width;
                    img.height = image.height;
                    img.loading = 'lazy';
                    img.dataset.mediaId = image.id;
                    
                    // 添加 srcset
                    img.srcset = `
                      ${image.src.replace('.jpg', '_300x.jpg')} 300w,
                      ${image.src.replace('.jpg', '_500x.jpg')} 500w,
                      ${image.src.replace('.jpg', '_800x.jpg')} 800w
                    `;
                    
                    newSlide.appendChild(img);
                    linkContainer.appendChild(newSlide);
                    
                    // 如果只显示悬停第二张图片，则跳出循环
                    if (clone.querySelector('.second-hover-image')) {
                      break;
                    }
                  }
                }
                
                // 更新图片链接
                const imageLink = clone.querySelector('.product-card__image a');
                if (imageLink) {
                  imageLink.href = `/products/${product.handle}`;
                }
                
                // ========== 更新品牌 ==========
                const vendorElement = clone.querySelector('.product-card__vendor span');
                if (vendorElement) {
                  vendorElement.textContent = product.vendor;
                }
                
                // ========== 更新产品标题 ==========
                const titleLink = clone.querySelector('.product-card__title a');
                if (titleLink) {
                  titleLink.href = `/products/${product.handle}`;
                  titleLink.textContent = product.title;
                  titleLink.setAttribute('aria-label', product.title);
                }
                
                // ========== 更新价格 ==========
                const priceElement = clone.querySelector('.main-price');
                if (priceElement) {
                  priceElement.textContent = `$${firstVariant.price}`;
                }
                
                // 更新隐藏的价格值（用于排序/筛选）
                const hiddenPrice = clone.querySelector('.price__container .hidden');
                if (hiddenPrice) {
                  hiddenPrice.textContent = Number(firstVariant.price) * 100;
                }
                
                // 更新对比价格（如果有）
                if (firstVariant.compare_at_price) {
                  const comparePrice = clone.querySelector('.price-item--regular');
                  if (comparePrice) {
                    comparePrice.textContent = `$${firstVariant.compare_at_price}`;
                    comparePrice.classList.remove('hidden');
                  }
                }
                
                // ========== 更新库存状态 ==========
                const inventoryStatus = clone.querySelector('[data-inventory-status]');
                if (inventoryStatus) {
                  const status = firstVariant.available ? 'in-stock' : 'out-of-stock';
                  inventoryStatus.dataset.inventoryStatus = status;
                  
                  const statusLabel = inventoryStatus.querySelector('.product-info__inventory-label');
                  if (statusLabel) {
                    statusLabel.dataset.inventoryStatus = status;
                    const statusText = statusLabel.querySelector('span:last-child');
                    if (statusText) {
                      statusText.textContent = firstVariant.available ? 'In stock' : 'Out of stock';
                    }
                  }
                }
                
                // ========== 更新 variant ID ==========
                const currentVariantDiv = clone.querySelector('.current-variant');
                if (currentVariantDiv) {
                  currentVariantDiv.textContent = firstVariant.id;
                }
                
                // ========== 更新选项/规格 ==========
                const swatchWrapper = clone.querySelector('product-card-swatch-option');
                if (swatchWrapper) {
                  swatchWrapper.dataset.variantId = firstVariant.id;
                  swatchWrapper.dataset.productId = product.id;
                  swatchWrapper.dataset.productUrl = `/products/${product.handle}`;
                }
                
                // 更新 radio input
                const variantInput = clone.querySelector('.swatch-option__value');
                if (variantInput && product.options.length > 0) {
                  const option = product.options[0];
                  variantInput.id = `${sectionId}--${option.position}-0-${product.id}`;
                  variantInput.name = `${option.name}-${sectionId}---`;
                  variantInput.value = option.values[0];
                  variantInput.dataset.value = option.values[0];
                }
                
                // ========== 更新 pickup 可用性 ==========
                const pickupWrapper = clone.querySelector('[x-data*="storeAvailabilites"]');
                if (pickupWrapper) {
                  // 更新 Alpine.js 数据
                  const availabilityData = {
                    storeAvailabilites: {
                      "NewFresh Inventory": firstVariant.available
                    },
                    pickupLocation: ["NewFresh Inventory"]
                  };
                  pickupWrapper.setAttribute('x-data', JSON.stringify(availabilityData));
                }
                
                // ========== 添加到容器 ==========
                container.appendChild(clone);
              });

              allProducts = [...allProducts, ...data.products];
              // 如果返回的产品少于 250，说明已经是最后一页
              if (data.products.length < 250) break;
              page++;
            }
            
            this.allProducts = allProducts;
            this.loading = false;
            
          } catch (error) {
            this.loading = false;
          }
        },
        
        // 新增：获取 collection handle 的辅助方法
        getCollectionHandle() {
          // 方法1: 从 URL 获取
          const path = window.location.pathname;
          const match = path.match(/\/collections\/([^\/]+)/);
          if (match) return match[1];
          
          // 方法2: 从页面元素获取（如果有的话）
          const collectionElement = document.querySelector('[data-collection-handle]');
          if (collectionElement) {
            return collectionElement.dataset.collectionHandle;
          }
          
          return null;
        },
        
        select(index) {
          this.currentTab = index;
        },
        
        async setTabSelect(handle, demoId) {
          this.currentHandle = handle;
        
            
        },
        
        loadData(index, handle) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            // const sectionId = 'dynamic-collection';

            // fetch(`/collections/${handle}?handle=${handle}&section_id=${sectionId}`)
            //   .then(response => response.text())
            //   .then(responseText => {
            //     const html = (new DOMParser()).parseFromString(responseText, 'text/html');
            //     console.log('html', html);
                
            //     const contentId = `collection_products__${handle}`;
            //     if (Shopify.designMode && document.getElementById(contentId)) {
            //       document.getElementById(contentId).remove();
            //     }
            //     const newContent = html.getElementById(contentId);
            //     console.log('newContent', newContent);

            //     if (newContent && !document.getElementById(contentId)) {
            //       // 使用 insertAdjacentHTML
            //       const list = document.getElementById('collection-list');
            //       console.log('list', list);
                  
            //       list.appendChild(newContent);
            //       this.loaded.push(selectedPage);
            //       document.dispatchEvent(new CustomEvent(`${ANIMATION_EVENT.revealItem}`));
            //     }
            //   });
            //   return
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            console.log('url', url);
            
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `xFeaturedCollection__${this.sectionId}__${index}`;
              if (Shopify.designMode && document.getElementById(contentId)) {
                document.getElementById(contentId).remove();
              }
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                //   const allItems = newContent.querySelectorAll(`#${contentId} .feature-collection__item`);
                //   console.log('allItems', allItems);
                //   if (allItems.length === 50) {
                //     await this.fetchAllProducts(handle, index);
                //   }
                this.loaded.push(selectedPage);
                document.dispatchEvent(new CustomEvent(`${ANIMATION_EVENT.revealItem}`));
              }
              this.loading = false;
            })
          }
        }
      }));
    });
  });
}
